module.exports = __webpack_public_path__ + "img/ClubhouseINTDay-6K-Fn3.b836b41f.gif";